import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=4bc502d6&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"
import style0 from "./Awards.vue?vue&type=style&index=0&id=4bc502d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc502d6",
  null
  
)

export default component.exports